import React, { useLayoutEffect, useState } from 'react';
import { BrowserView, isBrowser } from 'react-device-detect';
import { Link } from 'react-router-dom';

import BotaoLink from 'Component/BotaoLink';
import Icone from 'Component/Icone';
import Imagem from 'Component/Imagem';
import { useSubscription } from 'Hook/Subscription';
import { useAppSelector } from 'Store';
import { useIdentity, useRedirectUrl } from 'View/Hook/Authentication';

const MenuSuperior = (): React.ReactElement => {
  const [fundo, setFundo] = useState<boolean>(false);
  const identity = useIdentity();
  const subscription = useSubscription();
  const redirectUrl = useRedirectUrl();
  const exibirMenu = useAppSelector((estado) => estado.config.exibirMenu);

  useLayoutEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 30 && !fundo) {
        setFundo(true);
      } else {
        setFundo(false);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <nav
        id="navbar-top"
        className={[
          'navbar navbar-expand-lg navbar-dark',
          'tl-background-color tl-opacity',
          fundo && 'bg-gray bg-opacity-75 bd-filter-blur-1',
          'fixed-top top-0 z-index-5000',
          'w-100',
          'pb-0 px-0 px-sm-3',
          'animate__animated',
          exibirMenu ? 'animate__slideInDown' : 'animate__slideOutUp',
        ].class()}
      >
        <div className="container-fluid mx-3 mx-sm-4 py-2 fs-4 fw-lighter">
          <span className="navbar-brand" style={{ flex: 1 }}>
            <Link to={identity ? '/estudar' : '/'}>
              <Imagem
                src="logo.webp"
                height={isBrowser ? 40 : 30}
                className="p-0"
              />
            </Link>
          </span>

          {identity && (
            <BrowserView
              className="d-flex justify-content-center"
              style={{ flex: 2 }}
            >
              <ul className="navbar-nav">
                <li className="nav-item text-nowrap">
                  <Link
                    to="/estudar/meus-estudos"
                    className="nav-link text-white"
                  >
                    Meus estudos
                  </Link>
                </li>
                <li className="nav-item text-nowrap">
                  <Link
                    to="/estudar/categorias"
                    className="nav-link text-white"
                  >
                    Categorias
                  </Link>
                </li>
                <li className="nav-item text-nowrap">
                  <Link
                    to="/estudar/solicitacoes"
                    className="nav-link text-white"
                  >
                    Ajuda
                  </Link>
                </li>
                <li className="nav-item text-nowrap ms-3">
                  <Link
                    to="/estudar/buscar"
                    className="nav-link text-white me-5"
                  >
                    <Icone nome="search" />
                  </Link>
                </li>
              </ul>
            </BrowserView>
          )}

          <ul
            className="navbar-nav d-flex flex-row justify-content-end"
            style={{ flex: 1 }}
          >
            {identity ? (
              <React.Fragment>
                {subscription && subscription.status == 0 && (
                  <li className="nav-item text-nowrap">
                    <Link
                      to="/estudar/assinar"
                      className="nav-link text-danger me-3"
                    >
                      <Icone nome="patch-exclamation-fill" className="me-2" />
                      <span className="d-none d-sm-inline-block">Assinar</span>
                    </Link>
                  </li>
                )}
                {subscription === false && (
                  <li className="nav-item text-nowrap">
                    <Link
                      to="/estudar/assinar"
                      className="nav-link text-danger me-3"
                    >
                      <Icone nome="patch-exclamation-fill" className="me-2" />
                      <span className="d-none d-sm-inline-block">
                        Completar cadastro
                      </span>
                    </Link>
                  </li>
                )}
                {subscription && subscription.status == 2 && (
                  <li className="nav-item text-nowrap">
                    <Link
                      to="/estudar/minha-assinatura"
                      className="nav-link text-warning me-3"
                    >
                      <Icone nome="exclamation-diamond-fill" className="me-2" />
                      <span className="d-none d-sm-inline-block">
                        Temos um problema
                      </span>
                    </Link>
                  </li>
                )}
                {!!redirectUrl && (
                  <li className="nav-item text-nowrap">
                    <Link to={redirectUrl} className="nav-link text-white me-3">
                      Área do Professor
                    </Link>
                  </li>
                )}
                <li className="nav-item text-nowrap dropdown">
                  <a
                    className="nav-link active p-0"
                    aria-current="page"
                    href="#"
                    data-bs-toggle="dropdown"
                  >
                    <span className="pt-2 d-none d-sm-inline-block">
                      {identity.primeiro_nome}
                    </span>
                    <Imagem
                      src={identity.imagem}
                      width="36"
                      height="36"
                      className="rounded-circle ms-3 mt-2 mt-sm-n1 object-fit-cover"
                    />
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end animate__animated animate__fadeIn animate__faster border-0 shadow mr-2 position-absolute">
                    {subscription && (
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/estudar/minha-assinatura"
                        >
                          Minha assinatura
                        </Link>
                      </li>
                    )}
                    <li>
                      <Link className="dropdown-item" to="/estudar/perfil">
                        Meu perfil
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/estudar/alterar-senha"
                      >
                        Alterar senha
                      </Link>
                    </li>
                    <li>
                      <Link className="dropdown-item" to="/login?reset=true">
                        Sair
                      </Link>
                    </li>
                  </ul>
                </li>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {/* <BrowserView renderWithFragment>
                  <li className="nav-item">
                    <BotaoLink tema="outline-light" to="/cadastrar">
                      Cadastrar-se
                    </BotaoLink>
                  </li>
                </BrowserView> */}
                <li className="nav-item ms-2">
                  <BotaoLink to="/login">Acessar minha conta</BotaoLink>
                </li>
              </React.Fragment>
            )}
          </ul>
        </div>
      </nav>
      <div style={{ height: 100 }}></div>
    </React.Fragment>
  );
};

export default MenuSuperior;
